const DemandeStatusEnum = {
	EN_COURS: 'En cours',
	OK: 'Terminé',
	HS: 'En echec',
	TRAITEE: 'Traité',
	ABANDON: 'Abandon',
	NON_TRAITEE: 'Non traité',
} as const;

export type DemandeStatusType =
	(typeof DemandeStatusEnum)[keyof typeof DemandeStatusEnum];

export default DemandeStatusEnum;
